import { render, staticRenderFns } from "./MyPoints.vue?vue&type=template&id=9c19c70c&scoped=true"
import script from "./MyPoints.vue?vue&type=script&lang=js"
export * from "./MyPoints.vue?vue&type=script&lang=js"
import style0 from "./MyPoints.vue?vue&type=style&index=0&id=9c19c70c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c19c70c",
  null
  
)

export default component.exports